module.exports = __webpack_public_path__ + "img/qrcode.cc70f949.png";